import React, { useState, useEffect, useCallback } from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Typography 
} from '@mui/material';

interface LocalSelectProps {
  label: string;
  initialValue: string;
  anforderungNummer: number;
  field: string;
  disabled: boolean;
  options: { value: string; label: string }[];
  sx?: any;
  onLocalChange: (anforderungNummer: number, field: string, value: string) => void;
}

// Lokaler Select mit eigenem State (keine Parent-Re-Renders)
const LocalSelect = React.memo<LocalSelectProps>(({ 
  label, 
  initialValue, 
  anforderungNummer, 
  field, 
  disabled, 
  options, 
  sx = {}, 
  onLocalChange 
}) => {
  const [localValue, setLocalValue] = useState(initialValue);
  
  // Update lokaler Wert wenn sich initialValue ändert (z.B. nach Reset)
  useEffect(() => {
    setLocalValue(initialValue);
  }, [initialValue]);

  const handleChange = useCallback((e: any) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // Sofortiges lokales Update
    onLocalChange(anforderungNummer, field, newValue); // Sofortiges Parent-Update für Selects
  }, [anforderungNummer, field, onLocalChange]);

  return (
    <>
      <FormControl size="small" sx={{ minWidth: 150, mb: 2, ...sx }}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={localValue}
          label={label}
          disabled={disabled}
          onChange={handleChange}
        >
          {options.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
});

LocalSelect.displayName = 'LocalSelect';

export default LocalSelect;